export default "__VITE_ASSET__2b8711e2__"